export const phoneNumberStepConfig = {
  title: "Vimos que você já é correntista",
  headingText:
    "Selecione abaixo um dos números cadastrados na sua conta corrente:",
  fieldSlug: "phone_number",
  message: "Não reconheceu seu telefone? Entre em contato com o Banco do Brasil para alterar seus dados cadastrais"
}

export const addressStepConfig = {
  title: "Selecione seu endereço", 
  headingText:
    "Selecione abaixo um dos endereços cadastrados na sua conta corrente para envio do seu cartão Ourocard Fácil:",
  fieldSlug: "address",
  message: "Não reconheceu seu endereço? Entre em contato com o Banco do Brasil para alterar seus dados cadastrais"
}
